export const formFields = {
  subject: {
    id: "Sobre_o_que_deseja_falar__c",
    name: "Sobre_o_que_deseja_falar__c",
    label: "Sobre o que deseja falar",
    placeholder: "Selecione uma opção",
    required: true,
  },
  reason: {
    id: "Motivo_do_contato__c",
    name: "Motivo_do_contato__c",
    label: "Motivo do contato",
    placeholder: "Selecione uma opção",
    required: true,
  },
  subreason: {
    id: "Submotivo_do_contato__c",
    name: "Submotivo_do_contato__c",
    label: "Submotivo do contato",
    placeholder: "Selecione uma opção",
    required: true,
  },
};

export const subjectOptions = [
  { value: "", label: "--None--" },
  { value: "Cadastro", label: "Cadastro" },
  { value: "Configurações da Conta", label: "Configurações da Conta" },
  { value: "Estoque", label: "Estoque" },
  { value: "Finanças", label: "Finanças" },
  { value: "Fiscal", label: "Fiscal" },
  { value: "Frete e Expedição", label: "Frete e Expedição" },
  { value: "Integrações", label: "Integrações" },
  { value: "Outros", label: "Outros" },
  { value: "PDV", label: "PDV" },
  { value: "Relatórios", label: "Relatórios" },
  { value: "Serviços", label: "Serviços" },
  { value: "Vendas", label: "Vendas" },
];

/**
 * Returns an array of reason options based on the provided subject.
 *
 * This function takes a subject string and returns corresponding reason options
 * for form selection. Each reason option consists of a value and label property.
 * If no subject is provided or the subject doesn't match any case, a default
 * '--None--' option is returned.
 *
 * @param {string} [subject] - The selected subject that determines which reason options to return
 * @returns {Array<{value: string, label: string}>} An array of reason option objects
 */
export const getReasonOptions = (
  subject?: string
): Array<{ value: string; label: string }> => {
  switch (subject) {
    case "Cadastro":
      return [
        { value: "Anúncios", label: "Anúncios" },
        { value: "Produtos", label: "Produtos" },
      ];
    case "Configurações da Conta":
      return [
        { value: "Nota Fiscal", label: "Nota Fiscal" },
        { value: "Geral_Config_conta", label: "Geral" },
        { value: "Finanças_configuracoes_conta", label: "Finanças" },
        { value: "Cadastros", label: "Cadastros" },
        { value: "Vendas_configuracoes_conta", label: "Vendas" },
      ];
    case "Estoque":
      return [
        { value: "Reserva de estoque", label: "Reserva de estoque" },
        { value: "Depósitos", label: "Depósitos" },
        { value: "Sem estoque / Negativo", label: "Sem estoque / Negativo" },
        { value: "Fulfillment", label: "Fulfillment" },
        { value: "Gerar Inventário", label: "Gerar Inventário" },
        { value: "Saldo Multiempresa", label: "Saldo Multiempresa" },
        { value: "Lotes e validades", label: "Lotes e validades" },
        {
          value: "Configurações de estoque",
          label: "Configurações de estoque",
        },
        {
          value: "Edição, exclusão e ajustes de estoque",
          label: "Edição, exclusão e ajustes de estoque",
        },
      ];
    case "Finanças":
      return [
        { value: "Contas", label: "Contas" },
        { value: "Cobrança", label: "Cobrança" },
      ];
    case "Fiscal":
      return [
        { value: "Gestão de notas", label: "Gestão de notas" },
        { value: "Nota de Entrada", label: "Nota de Entrada" },
        { value: "Configuração de Nota", label: "Configuração de Nota" },
        { value: "Nota de Serviço", label: "Nota de Serviço" },
        { value: "NF de Consumidor", label: "NF de Consumidor" },
        { value: "GNRE", label: "GNRE" },
        { value: "SAT", label: "SAT" },
      ];
    case "Frete e Expedição":
      return [
        { value: "Gestão de fretes", label: "Gestão de fretes" },
        { value: "Formas de envio", label: "Formas de envio" },
        { value: "Gateways logísticos", label: "Gateways logísticos" },
        { value: "Expedição", label: "Expedição" },
      ];
    case "Integrações":
      return [
        { value: "Marketplace", label: "Marketplace" },
        { value: "API", label: "API" },
        { value: "Configurações", label: "Configurações" },
        { value: "Ecommerce", label: "Ecommerce" },
      ];
    case "Outros":
      return [
        { value: "Performance", label: "Performance" },
        { value: "Sustentabilidade", label: "Sustentabilidade" },
        { value: "Conta Digital", label: "Conta Digital" },
      ];
    case "PDV":
      return [
        { value: "Configuração", label: "Configuração" },
        { value: "Controle de Caixa", label: "Controle de Caixa" },
        { value: "NFC", label: "NFC" },
        { value: "Stone", label: "Stone" },
        { value: "Pré Venda", label: "Pré Venda" },
      ];
    case "Relatórios":
      return [
        { value: "Fiscal", label: "Fiscal" },
        { value: "Vendas - Relatórios", label: "Vendas" },
        { value: "Geral - Relatórios", label: "Geral" },
        { value: "Finanças - Relatórios", label: "Finanças" },
      ];
    case "Serviços":
      return [
        {
          value: "Suporte Técnico e Consultoria",
          label: "Suporte Técnico e Consultoria",
        },
        {
          value: "Contrato / Ordem de Serviço",
          label: "Contrato / Ordem de Serviço",
        },
      ];
    case "Vendas":
      return [{ value: "Processos de Venda", label: "Processos de Venda" }];
    default:
      return [];
  }
};

/**
 * Returns an array of subreason options based on the provided reason.
 *
 * This function takes a reason string and returns corresponding subreason options
 * for form selection. Each reason option consists of a value and label property.
 * If no reason is provided or the subject doesn't match any case, a default
 * '--None--' option is returned.
 *
 * @param {string} [reason] - The selected reason that determines which reason options to return
 * @returns {Array<{value: string, label: string}>} An array of reason option objects
 */
export const getSubReasonOptions = (
  reason?: string
): Array<{ value: string; label: string }> => {
  switch (reason) {
    // FRETE E EXPEDIÇÃO REASON START
    case "Gestão de fretes":
      return [
        { value: "Cotação de frete", label: "Cotação de frete" },
        { value: "Dúvida formas de envio", label: "Dúvida formas de envio" },
      ];
    case "Formas de envio":
      return [
        { value: "Correios", label: "Correios" },
        { value: "Amazon DBA", label: "Amazon DBA" },
        { value: "Shopee Envios", label: "Shopee Envios" },
        { value: "Intelipost", label: "Intelipost" },
        { value: "Jadlog", label: "Jadlog" },
        { value: "Magalu entregas", label: "Magalu entregas" },
        { value: "Mercado envios", label: "Mercado envios" },
        { value: "Olist envios", label: "Olist envios" },
        { value: "Total express", label: "Total express" },
        { value: "Mandaê", label: "Mandaê" },
        {
          value: "Correios Log+ (E-fulfillment)",
          label: "Correios Log+ (E-fulfillment)",
        },
        { value: "Loggi", label: "Loggi" },
        { value: "Outros", label: "Outros" },
      ];
    case "Gateways logísticos":
      return [
        { value: "Kangu", label: "Kangu" },
        { value: "Melhor envio", label: "Melhor envio" },
        { value: "Frenet", label: "Frenet" },
        { value: "FreteRápido", label: "FreteRápido" },
        { value: "Outros", label: "Outros" },
      ];
    case "Expedição":
      return [
        { value: "Concluir expedição", label: "Concluir expedição" },
        { value: "Imprimir Etiqueta", label: "Imprimir Etiqueta" },
        {
          value: "PLP Correios / Declaração de conteúdo / Objeto avulso",
          label: "PLP Correios / Declaração de conteúdo / Objeto avulso",
        },
        { value: "Rastreamento", label: "Rastreamento" },
      ];
    // FRETE E EXPEDIÇÃO REASON END
    // CADASTRO START
    case "Produtos":
      return [
        {
          value: "Exportar/importar via planilha",
          label: "Exportar/importar via planilha",
        },
        { value: "Fabricação", label: "Fabricação" },
        { value: "Filtros", label: "Filtros" },
        { value: "Impressão / Etiqueta", label: "Impressão / Etiqueta" },
        {
          value: "Incluir/Editar/Excluir/Restaurar",
          label: "Incluir/Editar/Excluir/Restaurar",
        },
        { value: "Lista de preços", label: "Lista de preços" },
        { value: "Numeração / SKU", label: "Numeração / SKU" },
        { value: "Outros", label: "Outros" },
      ];
    case "Anúncios":
      return [
        {
          value: "Alterações no produto Mercado Livre",
          label: "Alterações no produto Mercado Livre",
        },
        {
          value: "Alterações no produto outros canais",
          label: "Alterações no produto outros canais",
        },
        {
          value: "Alterações no produto Shopee",
          label: "Alterações no produto Shopee",
        },
        {
          value: "Ativar/Pausar/Clonar/Editar",
          label: "Ativar/Pausar/Clonar/Editar",
        },
        { value: "Importar / Planilha", label: "Importar / Planilha" },
        {
          value: "Mapeamento / Relacionamento",
          label: "Mapeamento / Relacionamento",
        },
        { value: "Precificação", label: "Precificação" },
        { value: "Calculadora de preços", label: "Calculadora de preços" },
      ];
    // CADASTRO END
    // CONFIGURAÇÕES DA CONTA START
    case "Nota Fiscal":
      return [
        {
          value: "Ambiente de homologação e produção",
          label: "Ambiente de homologação e produção",
        },
        { value: "Certificado digital", label: "Certificado digital" },
        {
          value: "Emissão / autorização automática NF",
          label: "Emissão / autorização automática NF",
        },
        {
          value: "Configurações de NF / Natureza",
          label: "Configurações de NF / Natureza",
        },
      ];
    case "Geral_Config_conta":
      return [
        { value: "Acessos", label: "Acessos" },
        {
          value: "Configurações de produtos",
          label: "Configurações de produtos",
        },
        {
          value: "Configurações de vendas",
          label: "Configurações de vendas",
        },
        {
          value: "Configurações do anúncio",
          label: "Configurações do anúncio",
        },
        { value: "Envio de emails", label: "Envio de emails" },
        { value: "Espaço de dados/anexos", label: "Espaço de dados/anexos" },
        { value: "Printnode", label: "Printnode" },
        { value: "Stone", label: "Stone" },
      ];
    case "Finanças - Configurações conta":
      return [
        {
          value: "Categoria e competência",
          label: "Categoria e competência",
        },
        { value: "Contas a pagar", label: "Contas a pagar" },
        { value: "Contas a receber", label: "Contas a receber" },
        { value: "Formas de recebimento", label: "Formas de recebimento" },
        { value: "Gateway de Pagamento", label: "Gateway de Pagamento" },
        { value: "GNRE", label: "GNRE" },
        {
          value: "Conta bancária / Financeira",
          label: "Conta bancária / Financeira",
        },
      ];
    case "Cadastros":
      return [
        {
          value: "Configurações de clientes e fornecedores",
          label: "Configurações de clientes e fornecedores",
        },
        { value: "Tabela de medidas", label: "Tabela de medidas" },
        { value: "Tags", label: "Tags" },
        { value: "Atributos", label: "Atributos" },
        { value: "Variações", label: "Variações" },
        { value: "Marcas", label: "Marcas" },
      ];
    case "Vendas_configuracoes_conta":
      return [
        { value: "Pedidos - PDV", label: "Pedidos - PDV" },
        { value: "Proposta comercial", label: "Proposta comercial" },
        { value: "CRM", label: "CRM" },
      ];
    // CONFIGURAÇÕES DA CONTA END
    // FINANÇAS REASON START
    case "Contas":
      return [
        { value: "Compartilhar", label: "Compartilhar" },
        {
          value: "Caixa (Contas bancárias / Financeira)",
          label: "Caixa (Contas bancárias / Financeira)",
        },
        {
          value: "Exportar/importar via planilha",
          label: "Exportar/importar via planilha",
        },
        { value: "Extratos Bancários", label: "Extratos Bancários" },
        {
          value: "Incluir / Baixar / Editar conta a pagar",
          label: "Incluir / Baixar / Editar conta a pagar",
        },
        {
          value: "Incluir / Baixar / Editar conta a receber",
          label: "Incluir / Baixar / Editar conta a receber",
        },
        { value: "Pix", label: "Pix" },
        {
          value: "Editar/Excluir/Incluir Lançamentos",
          label: "Editar/Excluir/Incluir Lançamentos",
        },
      ];
    case "Cobrança":
      return [
        {
          value: "Arquivo de Remessa/Retorno",
          label: "Arquivo de Remessa/Retorno",
        },
        { value: "Boletos homologação", label: "Boletos homologação" },
        { value: "Boletos junto com NF", label: "Boletos junto com NF" },
        { value: "Emissão de boletos", label: "Emissão de boletos" },
      ];
    // FINANÇAS REASON END
    // FISCAL REASON START
    case "Gestão de notas":
      return [
        { value: "Cancelar nota", label: "Cancelar nota" },
        { value: "Carta de correção", label: "Carta de correção" },
        { value: "Importar/Exportar XML", label: "Importar/Exportar XML" },
        { value: "Nota de transferência", label: "Nota de transferência" },
        {
          value: "Nota fiscal de devolução",
          label: "Nota fiscal de devolução",
        },
        { value: "SEFAZ", label: "SEFAZ" },
        { value: "tag XML", label: "tag XML" },
        {
          value: "Rejeição ou não envio da nota fiscal (transmissão à Sefaz)",
          label: "Rejeição ou não envio da nota fiscal (transmissão à Sefaz)",
        },
        {
          value: "Inutilização de Númeração",
          label: "Inutilização de Númeração",
        },
      ];
    case "Nota de Entrada":
      return [
        {
          value: "Formação de preço / Custo do produto",
          label: "Formação de preço / Custo do produto",
        },
        { value: "CTEs", label: "CTEs" },
        { value: "Manifestações de notas", label: "Manifestações de notas" },
      ];
    case "Configuração de Nota":
      return [
        { value: "Nota complementar", label: "Nota complementar" },
        { value: "Nota de bonificação", label: "Nota de bonificação" },
        { value: "Nota de exportação", label: "Nota de exportação" },
        { value: "Nota de importação", label: "Nota de importação" },
        { value: "Nota de remessa", label: "Nota de remessa" },
        { value: "Nota de retorno", label: "Nota de retorno" },
      ];
    case "Nota de Serviço":
      return [
        {
          value: "Cidades não homologadas para NFse",
          label: "Cidades não homologadas para NFse",
        },
        { value: "Nota de serviço", label: "Nota de serviço" },
        {
          value: "Emissão de NFse no portal nacional",
          label: "Emissão de NFse no portal nacional",
        },
        {
          value: "Importação de XML de NFse",
          label: "Importação de XML de NFse",
        },
      ];
    case "NF de Consumidor":
      return [
        {
          value: "Retornar NFCe para pendente",
          label: "Retornar NFCe para pendente",
        },
        { value: "Decreto 56670-22", label: "Decreto 56670-22" },
      ];
    case "GNRE":
      return [
        { value: "GNRE - Erro", label: "GNRE - Erro" },
        { value: "GNRE - Configuração", label: "GNRE - Configuração" },
      ];
    case "SAT":
      return [
        { value: "SAT - Erro", label: "SAT - Erro" },
        { value: "SAT - Configuração", label: "SAT - Configuração" },
      ];
    // FISCAL REASON END
    // INTEGRAÇÕES REASON START
    case "Marketplace":
      return [
        {
          value: "Integração com Mercado Livre",
          label: "Integração com Mercado Livre",
        },
        { value: "Integração com Shopee", label: "Integração com Shopee" },
        { value: "Integração com Amazon", label: "Integração com Amazon" },
        {
          value: "Integração com Magazine Luiza",
          label: "Integração com Magazine Luiza",
        },
        {
          value: "Integração com Americanas",
          label: "Integração com Americanas",
        },
        { value: "Integração com Shein", label: "Integração com Shein" },
        { value: "Outros", label: "Outros" },
      ];
    case "API":
      return [
        { value: "IPs dos servidores", label: "IPs dos servidores" },
        { value: "Token API", label: "Token API" },
        { value: "Webhooks", label: "Webhooks" },
      ];
    case "Configurações":
      return [
        { value: "Adicionar integração", label: "Adicionar integração" },
        { value: "Canais de venda", label: "Canais de venda" },
        {
          value: "Envio código de rastreio",
          label: "Envio código de rastreio",
        },
        {
          value: "Envio de estoque para ecommerce",
          label: "Envio de estoque para ecommerce",
        },
        {
          value: "Envio de notas para ecommerce",
          label: "Envio de notas para ecommerce",
        },
        { value: "Envio de preço", label: "Envio de preço" },
        { value: "Envio de produto", label: "Envio de produto" },
        { value: "Regras de Estoque", label: "Regras de Estoque" },
        {
          value: "Tabela de medidas Mercado Livre",
          label: "Tabela de medidas Mercado Livre",
        },
      ];
    case "Ecommerce":
      return [
        {
          value: "Integração com Nuvemshop",
          label: "Integração com Nuvemshop",
        },
        { value: "Integração com Tray", label: "Integração com Tray" },
        {
          value: "Integração com Loja integrada",
          label: "Integração com Loja integrada",
        },
        {
          value: "Integração com Woocommerce",
          label: "Integração com Woocommerce",
        },
        { value: "Integração com Shopify", label: "Integração com Shopify" },
        {
          value: "Integração com Bagy/Dooca",
          label: "Integração com Bagy/Dooca",
        },
        { value: "Outros", label: "Outros" },
      ];
    // INTEGRAÇÕES REASON END
    // VENDAS REASON START
    case "Processos de Venda":
      return [
        {
          value: "Atualizar Situação de Envio",
          label: "Atualizar Situação de Envio",
        },
        { value: "Importação do ecommerce", label: "Importação do ecommerce" },
        { value: "Compartilhamento", label: "Compartilhamento" },
        { value: "Descontos", label: "Descontos" },
        { value: "Devoluções", label: "Devoluções" },
        { value: "Duplicidade", label: "Duplicidade" },
        { value: "Envio para a expedição", label: "Envio para a expedição" },
        { value: "Envio para a separação", label: "Envio para a separação" },
        {
          value: "Faturar pedidos agrupadamente",
          label: "Faturar pedidos agrupadamente",
        },
        { value: "Gerar nota fiscal", label: "Gerar nota fiscal" },
        { value: "OMS", label: "OMS" },
        { value: "PDV / Pré venda", label: "PDV / Pré venda" },
        { value: "Propostas comerciais", label: "Propostas comerciais" },
        {
          value: "Situação / ocorrência da venda",
          label: "Situação / ocorrência da venda",
        },
        {
          value: "Incluir / Editar / Excluir / Cancelar",
          label: "Incluir / Editar / Excluir / Cancelar",
        },
        { value: "Vale troca", label: "Vale troca" },
        { value: "Vendas sob encomenda", label: "Vendas sob encomenda" },
      ];
    // VENDAS REASON END
    // RELATÓRIOS REASON START
    case "Fiscal":
      return [
        {
          value: "Sintegra dúvidas / erros",
          label: "Sintegra dúvidas / erros",
        },
        { value: "SPED dúvidas / erros", label: "SPED dúvidas / erros" },
        { value: "Nota de Entrada", label: "Nota de Entrada" },
        { value: "Nota de Saida", label: "Nota de Saida" },
      ];
    case "Vendas - Relatórios":
      return [
        {
          value: "Relatório de performance",
          label: "Relatório de performance",
        },
        { value: "Venda", label: "Venda" },
      ];
    case "Geral - Relatórios":
      return [
        { value: "Relatório Personalizado", label: "Relatório Personalizado" },
        { value: "CRM", label: "CRM" },
        { value: "Custo ecommerce", label: "Custo ecommerce" },
        { value: "Expedição", label: "Expedição" },
        { value: "Multiempresas", label: "Multiempresas" },
        { value: "Necessidade de compras", label: "Necessidade de compras" },
        { value: "Ordens de serviço", label: "Ordens de serviço" },
        { value: "Planilha", label: "Planilha" },
        { value: "Relatório ABC", label: "Relatório ABC" },
        {
          value: "Visão financeira de estoque",
          label: "Visão financeira de estoque",
        },
        { value: "Suprimentos", label: "Suprimentos" },
        { value: "Cadastros", label: "Cadastros" },
        { value: "Separação", label: "Separação" },
      ];
    case "Finanças - Relatórios":
      return [
        { value: "Balancete", label: "Balancete" },
        { value: "DRE", label: "DRE" },
        { value: "Fluxo de Caixa", label: "Fluxo de Caixa" },
        {
          value: "Contas a pagar e receber",
          label: "Contas a pagar e receber",
        },
      ];
    // RELATÓRIOS REASON END
    // SERVIÇOS REASON START
    case "Suporte Técnico e Consultoria":
      return [
        {
          value: "Alteração login da conta",
          label: "Alteração login da conta",
        },
        { value: "Backup", label: "Backup" },
        { value: "Canais de atendimento", label: "Canais de atendimento" },
        { value: "Canal de ideias", label: "Canal de ideias" },
        { value: "Consultoria", label: "Consultoria" },
        { value: "Multiempresa", label: "Multiempresa" },
        { value: "Tarefa de Exclusão", label: "Tarefa de Exclusão" },
      ];
    // SERVIÇOS REASON END
    // OUTROS REASON START
    case "Performance":
      return [
        { value: "Problemas no SINTEGRA", label: "Problemas no SINTEGRA" },
        { value: "Erros no multiempresas", label: "Erros no multiempresas" },
        { value: "Acesso a conta", label: "Acesso a conta" },
        { value: "Agenda", label: "Agenda" },
        { value: "Alteração da conta", label: "Alteração da conta" },
        { value: "Central de notificações", label: "Central de notificações" },
        { value: "Dashboard", label: "Dashboard" },
        {
          value: "Dúvidas - Módulos em Beta",
          label: "Dúvidas - Módulos em Beta",
        },
        { value: "Extensões", label: "Extensões" },
        { value: "Interface do usuário", label: "Interface do usuário" },
        {
          value: "Migração da conta para troca de CNPJ",
          label: "Migração da conta para troca de CNPJ",
        },
      ];
    case "Sustentabilidade":
      return [
        { value: "Lentidão no sistema", label: "Lentidão no sistema" },
        { value: "Servidor de e-mail", label: "Servidor de e-mail" },
        { value: "Authenticador da conta", label: "Authenticador da conta" },
        {
          value:
            "Compatibilidade de equipamentos (impressoras, SAT, entre outros)",
          label:
            "Compatibilidade de equipamentos (impressoras, SAT, entre outros)",
        },
        { value: "Atualização do sistema", label: "Atualização do sistema" },
      ];
    case "Conta Digital":
      return [{ value: "Olist conta digital", label: "Olist conta digital" }];
    // OUTROS REASON END

    case "Minha conta (Financeiro Olist ERP)":
      return [
        {
          value: "Alteração da forma de recebimento de cobrança",
          label: "Alteração da forma de recebimento de cobrança",
        },
        {
          value: "Alteração da periodicidade de cobrança",
          label: "Alteração da periodicidade de cobrança",
        },
        {
          value: "Alteração de e-mail do administrador",
          label: "Alteração de e-mail do administrador",
        },
        { value: "Boleto não registrado", label: "Boleto não registrado" },
        { value: "Cancelamento de conta", label: "Cancelamento de conta" },
        {
          value: "Comprovante de pagamento / Promessa / Liberação de conta",
          label: "Comprovante de pagamento / Promessa / Liberação de conta",
        },
        { value: "Detalhamentos cobranças", label: "Detalhamentos cobranças" },
        { value: "Downgrade", label: "Downgrade" },
        { value: "Dúvidas gerais", label: "Dúvidas gerais" },
        { value: "Dúvidas sobre extensões", label: "Dúvidas sobre extensões" },
        { value: "Erro cobrança", label: "Erro cobrança" },
        {
          value: "Nota fiscal de serviço (Solicitação/Dúvidas)",
          label: "Nota fiscal de serviço (Solicitação/Dúvidas)",
        },
        { value: "Reajustes", label: "Reajustes" },
        { value: "Reativação de conta", label: "Reativação de conta" },
        {
          value: "Reenvio do Boleto de mensalidade",
          label: "Reenvio do Boleto de mensalidade",
        },
        { value: "Renegociações", label: "Renegociações" },
        { value: "Renovação de plano", label: "Renovação de plano" },
        {
          value: "Solicitação de boleto antecipado",
          label: "Solicitação de boleto antecipado",
        },
        { value: "Upgrade", label: "Upgrade" },
      ];
    default:
      return [];
  }
};

export interface IField {
  type: "text" | "radio" | "select" | "plaintext";
  label: string;
  id?: string;
  options?: { value: string; label: string }[];
}

export const getFieldsByReason = ({
  reason,
  subject,
  subreason,
}: {
  subject: string;
  reason: string;
  subreason?: string;
}): IField[] => {
  if (subject === "Estoque") {
    switch (reason) {
      case "Reserva de estoque":
      case "Fulfillment":
        return [
          {
            type: "text",
            label: "SKU / Descrição",
            id: "SKU_Descricao__c",
          },
          {
            type: "text",
            label: "Número do pedido / Nota",
            id: "Numero_do_pedido_Nota__c",
          },
        ];
      case "Depósitos":
        return [
          { type: "text", label: "Qual Depósito?", id: "Qual_Deposito__c" },
        ];
      case "Sem estoque / Negativo":
        return [
          {
            type: "text",
            label: "SKU / Descrição",
            id: "SKU_Descricao__c",
          },
          {
            type: "radio",
            label: "Ocorreu uma venda sem estoque?",
            id: "Ocorreu_uma_venda_sem_estoque__c",
            options: [
              { value: "Sim", label: "Sim" },
              { value: "Não", label: "Não" },
            ],
          },
          {
            type: "text",
            label: "Número do pedido / Nota",
            id: "Numero_do_pedido_Nota__c",
          },
        ];
      case "Saldo Multiempresa":
      case "Edição, exclusão e ajustes de estoque":
        return [
          {
            type: "text",
            label: "SKU / Descrição",
            id: "SKU_Descricao__c",
          },
        ];
      case "Lotes e validades":
        return [
          {
            type: "text",
            label: "SKU / Descrição",
            id: "SKU_Descricao__c",
          },
          {
            type: "text",
            label: "Qual lote?",
            id: "Qual_Lote__c",
          },
        ];
      default:
        return [];
    }
  }

  if (subject === "Frete e Expedição") {
    switch (reason) {
      case "Gestão de fretes":
        switch (subreason) {
          case "Cotação de frete":
            return [
              {
                type: "text",
                label: "Número do pedido / Nota",
                id: "Numero_do_pedido_Nota__c",
              },
              {
                type: "text",
                label: "Qual forma de envio?",
                id: "Qual_forma_de_envio__c",
              },
            ];
          case "Dúvida formas de envio":
            return [
              {
                type: "text",
                label: "Qual forma de envio?",
                id: "Qual_forma_de_envio__c",
              },
            ];
          default:
            return [];
        }
      case "Formas de envio":
      case "Gateways logísticos":
        return [
          {
            type: "text",
            label: "Número do pedido / Nota",
            id: "Numero_do_pedido_Nota__c",
          },
        ];
      case "Expedição":
        switch (subreason) {
          case "Concluir expedição":
          case "Imprimir Etiqueta":
          case "PLP Correios / Declaração de conteúdo / Objeto avulso":
            return [
              {
                type: "text",
                label: "Qual expedição?",
                id: "Qual_expedicao__c",
              },
            ];
          case "Rastreamento":
            return [
              {
                type: "text",
                label: "Número do pedido / Nota",
                id: "Numero_do_pedido_Nota__c",
              },
            ];
          default:
            return [];
        }
      default:
        return [];
    }
  }

  if (subject === "Cadastro") {
    switch (reason) {
      case "Produtos":
        switch (subreason) {
          case "Exportar/importar via planilha":
            return [
              {
                type: "text",
                label: "Qual erro esta ocorrendo?",
                id: "Qual_erro_esta_ocorrendo__c",
              },
            ];
          case "Filtros":
            return [
              {
                type: "text",
                label: "Quais filtros foram aplicados?",
                id: "Quais_Filtros_foram_aplicados__c",
              },
            ];
          case "Impressão / Etiqueta":
            return [
              {
                type: "plaintext",
                label:
                  "Verique em seu computador: Painel de controle > Dispositivos de impressora > clicar com o botão direito em cima da impressora e clicar em preferências de impressão. E nos envie as medidas do papel configuradas.",
                id: "informativo",
              },
              {
                type: "text",
                label: "Largura total da bobina:",
                id: "Largura_total_da_bobina__c",
              },
              {
                type: "text",
                label: "Largura da etiqueta:",
                id: "Largura_da_etiqueta__c",
              },
              {
                type: "text",
                label: "Altura da etiqueta:",
                id: "Altura_da_etiqueta__c",
              },
              {
                type: "text",
                label: "Margem esquerda:",
                id: "Margem_esquerda__c",
              },
              {
                type: "text",
                label: "Espaçamento entre colunas:",
                id: "Espacamento_entre_colunas__c",
              },
              {
                type: "text",
                label: "Qual nome da etiqueta cadastrada na Olist?",
                id: "Nome_da_etiqueta_cadastrada_na_Olist__c",
              },
            ];
          case "Lista de preços":
            return [
              {
                type: "text",
                label: "Qual a lista?",
                id: "Qual_a_lista__c",
              },
              {
                type: "text",
                label: "SKU / Descrição",
                id: "SKU_Descricao__c",
              },
            ];
          case "Fabricação":
          case "Incluir/Editar/Excluir/Restaurar":
          case "Numeração / SKU":
          case "Outros":
            return [
              {
                type: "text",
                label: "SKU / Descrição",
                id: "SKU_Descricao__c",
              },
            ];
          default:
            return [];
        }
      case "Anúncios":
        switch (subreason) {
          case "Alterações no produto Mercado Livre":
          case "Alterações no produto outros canais":
          case "Alterações no produto Shopee":
          case "Ativar/Pausar/Clonar/Editar":
          case "Mapeamento / Relacionamento":
          case "Precificação":
          case "Calculadora de preços":
            return [
              {
                type: "text",
                label: "SKU / Descrição",
                id: "SKU_Descricao__c",
              },
              {
                type: "text",
                label: "Qual o identificador do anúncio?",
                id: "Qual_o_identificador_do_anuncio__c",
              },
            ];
          case "Importar / Planilha":
            return [
              {
                type: "text",
                label: "Qual integração?",
                id: "Qual_integracao__c",
              },
            ];
          default:
            return [];
        }
      default:
        return [];
    }
  }

  if (subject === "Configurações da Conta") {
    switch (reason) {
      case "Nota Fiscal":
        if (subreason === "Configurações de NF / Natureza") {
          return [
            {
              type: "text",
              label: "Qual natureza de Operação?",
              id: "Qual_natureza_de_Operacao__c",
            },
          ];
        }
        return [];
      case "Geral_Config_conta":
        if (subreason === "Stone") {
          return [
            {
              type: "text",
              label: "CNPJ cadastrado na Stone?",
              id: "CNPJ_cadastrado_na_Stone__c",
            },
            {
              type: "text",
              label: "Qual Stone Code?",
              id: "Qual_Stone_Code__c",
            },
            {
              type: "text",
              label: "Modelo da Maquininha",
              id: "Modelo_da_Maquininha__c",
            },
          ];
        }
        return [];
      case "Finanças - Configurações conta":
        switch (subreason) {
          case "Categoria e competência":
            return [
              {
                type: "text",
                label: "Qual a categoria?",
                id: "Qual_Categoria__c",
              },
            ];
          case "Formas de recebimento":
            return [
              {
                type: "text",
                label: "Qual forma de recebimento?",
                id: "Qual_forma_de_recebimento__c",
              },
            ];
          case "Gateway de Pagamento":
            return [
              {
                type: "text",
                label: "Qual gateway?",
                id: "Qual_Gateway__c",
              },
            ];
          case "Conta bancária / Financeira":
            return [
              {
                type: "text",
                label: "Qual a conta?",
                id: "Qual_Conta__c",
              },
            ];
          default:
            return [];
        }
      default:
        return [];
    }
  }

  if (subject === "Finanças") {
    switch (reason) {
      case "Contas":
        switch (subreason) {
          case "Compartilhar":
            return [
              {
                type: "text",
                label: "Qual a conta?",
                id: "Qual_Conta__c",
              },
            ];
          case "Caixa (Contas bancárias / Financeira)":
            return [
              {
                type: "text",
                label: "Qual a conta bancária?",
                id: "Qual_a_conta_bancaria__c",
              },
            ];
          case "Extratos Bancários":
            return [
              {
                type: "text",
                label: "Qual extrato bancário?",
                id: "Qual_extrato_bancario__c",
              },
            ];
          case "Incluir / Baixar / Editar conta a pagar":
          case "Incluir / Baixar / Editar conta a receber":
          case "Pix":
          case "Editar/Excluir/Incluir Lançamentos":
            return [
              {
                type: "text",
                label: "Qual a conta? (caso exista)",
                id: "Qual_a_conta_caso_exista__c",
              },
            ];
          default:
            return [];
        }
      case "Cobrança":
        switch (subreason) {
          case "Arquivo de Remessa/Retorno":
            return [
              {
                type: "text",
                label: "Número remessa",
                id: "Numero_remessa__c",
              },
            ];
          case "Boletos homologação":
            return [
              {
                type: "text",
                label: "Dados bancários do titular da conta:",
                id: "Dados_bancarios_do_titular_da_conta__c",
              },
              {
                type: "text",
                label: "Agência e dígito verificador:",
                id: "Agencia_e_digito_verificador__c",
              },
              {
                type: "text",
                label: "Conta bancária e dígito verificador:",
                id: "Conta_bancaria_e_digito_verificador__c",
              },
              {
                type: "text",
                label: "Código beneficiário e dígito verificador:",
                id: "Codigo_beneficiario_e_digito_verificador__c",
              },
              {
                type: "text",
                label: "Contrato:",
                id: "Contrato__c",
              },
              {
                type: "text",
                label: "Convênio:",
                id: "Convenio__c",
              },
              {
                type: "text",
                label: "Carteira/Variação:",
                id: "Carteira_Variacao__c",
              },
              {
                type: "text",
                label: "CNAB:",
                id: "CNAB__c",
              },
              {
                type: "text",
                label: "Tipo de emissão:",
                id: "Tipo_de_emissao__c",
              },
              {
                type: "text",
                label: "Instruções:",
                id: "Instrucoes__c",
              },
              {
                type: "text",
                label: "Aceite:",
                id: "Aceite__c",
              },
              {
                type: "text",
                label: "Espécie dos títulos:",
                id: "Especie_dos_titulos__c",
              },
            ];
          case "Boletos junto com NF":
            return [
              {
                type: "text",
                label: "Qual NF?",
                id: "Qual_NF__c",
              },
            ];
          default:
            return [];
        }
      default:
        return [];
    }
  }

  if (subject === "Fiscal") {
    switch (reason) {
      case "Gestão de notas":
        switch (subreason) {
          // TODO: Validar se o campo está correto, na planilha referência "Qual a NF ?"
          case "Cancelar nota":
            return [
              {
                type: "text",
                label: "Qual NF?",
                id: "Qual_NF__c",
              },
              {
                type: "text",
                label: "Qual o erro esta aparecendo?",
                id: "Qual_o_erro_esta_aparecendo__c",
              },
            ];
          case "SEFAZ":
          case "tag XML":
          case "Rejeição ou não envio da nota fiscal (transmissão à Sefaz)":
            return [
              {
                type: "text",
                label: "Qual NF?",
                id: "Qual_NF__c",
              },
            ];
          case "Carta de correção":
            return [
              {
                type: "text",
                label: "Qual a necessidade da correção?",
                id: "Qual_a_necessidade_da_correcao__c",
              },
            ];
          case "Nota fiscal de devolução":
            return [
              {
                type: "text",
                label: "Qual a NF de devolução?",
                id: "Qual_a_NF_de_devolucao__c",
              },
              {
                type: "text",
                label: "Qual a NF de origem?",
                id: "Qual_a_NF_de_origem__c",
              },
            ];
          case "Inutilização de Númeração":
            return [
              {
                type: "text",
                label: "Qual a numeração que você quer inutilizar?",
                id: "Qual_numeracao_inutilizar__c",
              },
            ];
          default:
            return [];
        }
      case "Nota de Entrada":
        switch (subreason) {
          case "Formação de preço / Custo do produto":
            return [
              {
                type: "text",
                label: "Qual NF?",
                id: "Qual_NF__c",
              },
              {
                type: "text",
                label: "Exemplo de produto",
                id: "Exemplo_de_produto__c",
              },
            ];
          case "Manifestações de notas":
            return [
              {
                type: "text",
                label: "Qual NF?",
                id: "Qual_NF__c",
              },
            ];
          default:
            return [];
        }
      case "Configuração de Nota":
        switch (subreason) {
          case "Nota complementar":
            return [
              {
                type: "text",
                label: "Qual a NF de origem?",
                id: "Qual_a_NF_de_origem__c",
              },
            ];
          case "Nota de exportação":
            return [
              {
                type: "text",
                label: "Qual NF?",
                id: "Qual_NF__c",
              },
            ];
          case "Nota de importação":
            return [
              {
                type: "text",
                label: "Qual NF?",
                id: "Qual_NF__c",
              },
              {
                type: "plaintext",
                label: "Anexe o espelho da nota e o DI:",
                id: "informativo",
              },
            ];
          default:
            return [];
        }
      case "Nota de Serviço":
        if (subreason === "Nota de serviço") {
          return [
            {
              type: "text",
              label: "Qual NF?",
              id: "Qual_NF__c",
            },
          ];
        }
        return [];
      case "NF de Consumidor":
        if (subreason === "Retornar NFCe para pendente") {
          return [
            {
              type: "text",
              label: "Qual NF?",
              id: "Qual_NF__c",
            },
          ];
        }
        return [];
      case "GNRE":
        if (subreason === "GNRE - Erro") {
          return [
            {
              type: "text",
              label: "Qual NF?",
              id: "Qual_NF__c",
            },
          ];
        }
        return [];
      case "SAT":
        switch (subreason) {
          case "SAT - Erro":
            return [
              {
                type: "text",
                label: "Qual NF?",
                id: "Qual_NF__c",
              },
              {
                type: "text",
                label: "Qual o erro apresentado em tela?",
                id: "Qual_o_erro_apresentado_em_tela__c",
              },
            ];
          case "SAT - Configuração":
            return [
              {
                type: "text",
                label: "Qual o modelo do SAT?",
                id: "Qual_o_modelo_do_SAT__c",
              },
              {
                type: "text",
                label: "Seu SAT já foi ativado pelo fornecedor?",
                id: "Seu_SAT_ja_foi_ativado_pelo_fornecedor__c",
              },
            ];
          default:
            return [];
        }
      default:
        return [];
    }
  }

  if (subject === "Integrações") {
    switch (reason) {
      case "Marketplace":
        if (subreason === "Outros") {
          return [
            {
              type: "text",
              label: "Qual Marketplace?",
              id: "Qual_Marketplace__c",
            },
          ];
        }
        return [];
      case "API":
        if (subreason === "Token API") {
          return [
            {
              type: "plaintext",
              label:
                "Se estiver realizando uma requisição, por favor anexe a chamada completa (cURL)",
              id: "informativo",
            },
          ];
        }
        return [];
      case "Configurações":
        switch (subreason) {
          case "Adicionar integração":
          case "Envio código de rastreio":
          case "Envio de estoque para ecommerce":
          case "Envio de notas para ecommerce":
          case "Envio de preço":
          case "Envio de produto":
          case "Regras de Estoque":
            return [
              {
                type: "text",
                label: "Qual integração?",
                id: "Qual_integracao__c",
              },
            ];
          case "Canais de venda":
            return [
              {
                type: "text",
                label: "Qual canal de venda?",
                id: "Qual_canal_de_venda__c",
              },
            ];
          case "Tabela de medidas Mercado Livre":
            return [
              {
                type: "text",
                label: "Qual o nome da tabela?",
                id: "Qual_o_nome_da_Tabela__c",
              },
            ];
          default:
            return [];
        }
      case "Ecommerce":
        if (subreason === "Outros") {
          return [
            {
              type: "text",
              label: "Qual Ecommerce?",
              id: "Qual_ecommerce__c",
            },
          ];
        }
        return [];
      default:
        return [];
    }
  }

  if (subject === "Vendas" && reason === "Processos de Venda") {
    switch (subreason) {
      case "Atualizar Situação de Envio":
      case "Compartilhamento":
      case "Descontos":
      case "Devoluções":
      case "Duplicidade":
      case "Envio para a expedição":
      case "Envio para a separação":
      case "Gerar nota fiscal":
      case "PDV / Pré venda":
      case "Situação / ocorrência da venda":
      case "Incluir / Editar / Excluir / Cancelar":
      case "Vale troca":
      case "Vendas sob encomenda":
        return [
          {
            type: "text",
            label: "Qual o pedido?",
            id: "Qual_o_pedido__c",
          },
        ];
      case "OMS":
        return [
          {
            type: "text",
            label: "Qual integração?",
            id: "Qual_integracao__c",
          },
        ];
      case "Importação do ecommerce":
        return [
          {
            type: "text",
            label: "Qual integração?",
            id: "Qual_integracao__c",
          },
          {
            type: "text",
            label: "Qual o ID do pedido?",
            id: "Qual_o_ID_do_pedido__c",
          },
        ];
      case "Propostas comerciais":
        return [
          {
            type: "text",
            label: "Qual proposta?",
            id: "Qual_proposta__c",
          },
        ];
      default:
        return [];
    }
  }

  if (subject === "Relatórios") {
    switch (reason) {
      case "Fiscal":
        switch (subreason) {
          case "Nota de Entrada":
          case "Nota de Saida":
            return [
              {
                type: "text",
                label: "Quais os filtros que esta utilizando?",
                id: "Quais_os_filtros_que_esta_utilizando__c",
              },
            ];
          default:
            return [];
        }
      case "Vendas - Relatórios":
        switch (subreason) {
          case "Relatório de performance":
          case "Venda":
            return [
              {
                type: "text",
                label: "Quais os filtros que esta utilizando?",
                id: "Quais_os_filtros_que_esta_utilizando__c",
              },
            ];
          default:
            return [];
        }
      case "Geral - Relatórios":
        switch (subreason) {
          case "Relatório Personalizado":
          case "CRM":
          case "Expedição":
          case "Multiempresas":
          case "Necessidade de compras":
          case "Ordens de serviço":
          case "Planilha":
          case "Relatório ABC":
          case "Visão financeira de estoque":
          case "Suprimentos":
          case "Cadastros":
          case "Separação":
            return [
              {
                type: "text",
                label: "Quais os filtros que esta utilizando?",
                id: "Quais_os_filtros_que_esta_utilizando__c",
              },
            ];
          case "Custo ecommerce":
            return [
              {
                type: "text",
                label: "Quais os filtros que esta utilizando?",
                id: "Quais_os_filtros_que_esta_utilizando__c",
              },
              // TODO: Validar se o campo está correto, na planilha
              // referência "Qual Ecommerce/Marketplace?"
              {
                type: "text",
                label: "Qual Ecommerce/Marketplace?",
                id: "Qual_ecommerce__c",
              },
              {
                type: "text",
                label: "Algum pedido especifico, informe:",
                id: "Algum_pedido_especifico_infome__c",
              },
            ];
          default:
            return [];
        }
      case "Finanças - Relatórios":
        return [
          {
            type: "text",
            label: "Quais os filtros que esta utilizando?",
            id: "Quais_os_filtros_que_esta_utilizando__c",
          },
        ];
      default:
        return [];
    }
  }

  if (subject === "Serviços") {
    switch (reason) {
      case "Suporte Técnico e Consultoria":
        switch (subreason) {
          case "Multiempresa":
            return [
              {
                type: "text",
                label: "Quais os CNPJs das empresas conectadas?",
                id: "Quais_os_CNPJ_s_das_empresas_conectadas__c",
              },
            ];
          default:
            return [];
        }
      case "Contrato / Ordem de Serviço":
        return [
          {
            type: "text",
            label: "Qual o contrato / ordem de serviço?",
            id: "Qual_o_contrato_ordem_de_servico__c",
          },
        ];
      default:
        return [];
    }
  }

  if (subject === "Outros") {
    switch (reason) {
      case "Performance":
        switch (subreason) {
          case "Erros no multiempresas":
            return [
              {
                type: "text",
                label: "Qual erro apresentado?",
                id: "Qual_erro_apresentado__c",
              },
            ];
          case "Dashboard":
            return [
              {
                type: "text",
                label: "Quais filtros foram aplicados?",
                id: "Quais_Filtros_foram_aplicados__c",
              },
            ];
          case "Extensões":
            return [
              {
                type: "text",
                label: "Qual extensão?",
                id: "Qual_extenssao__c",
              },
            ];
          default:
            return [];
        }
      case "Sustentabilidade":
        if (subreason === "Lentidão no sistema") {
          return [
            {
              type: "text",
              label: "Qual navegador você testou?",
              id: "Qual_navegador_voce_testou__c",
            },
          ];
        }
        return [];
      default:
        return [];
    }
  }

  if (subject === "PDV") {
    switch (reason) {
      case "Controle de Caixa":
        return [
          {
            type: "text",
            label: "Quais filtros foram aplicados?",
            id: "Quais_Filtros_foram_aplicados__c",
          },
        ];
      case "NFC":
        return [
          {
            type: "text",
            label: "Qual o número do pedido/NF?",
            id: "Qual_o_numero_do_pedido_NF__c",
          },
        ];
      case "Pré Venda":
        return [
          {
            type: "text",
            label: "Qual o número do pedido?",
            id: "Qual_o_numero_do_pedido__c",
          },
        ];
      default:
        return [];
    }
  }

  if (
    subject === "Financeiro (Olist ERP)" &&
    reason === "Minha conta (Financeiro Olist ERP)"
  ) {
    switch (subreason) {
      case "Alteração da forma de recebimento de cobrança":
      case "Alteração da periodicidade de cobrança":
        return [
          {
            type: "text",
            label: "Qual a alteração gostaria de realizar?",
            id: "Qual_a_alteracao_gostaria_de_realizar__c",
          },
        ];
      case "Alteração de e-mail do administrador":
        return [
          {
            type: "text",
            label: "Você possui acesso ao email cadastrado?",
            id: "Voce_possui_acesso_ao_email_cadastrado__c",
          },
          {
            type: "plaintext",
            label: `Caso não possua, peço que anexe os documentos abaixo:
              Uma foto do seu rosto segurando um documento com foto (ex: RG, CNH),
              o contrato social da empresa ou certificado MEI, uma foto do
              Documento (RG, CNH)`,
          },
        ];
      case "Comprovante de pagamento / Promessa / Liberação de conta":
        return [
          {
            type: "plaintext",
            label:
              "Libere sua conta para uso. Acesse o menu lateral > Minha Conta e clique no botão liberar conta. Na sequência, confirme clicando mais uma vez em liberar conta.",
          },
          {
            type: "plaintext",
            label:
              "Ou caso deseje continuar com a solucitação por favor anexe o comprovante de pagamento para analise e liberação da conta.",
          },
          // TO-DO: Adicionar nova mensagem em plaintext
        ];
      case "Detalhamentos cobranças":
        return [
          {
            type: "text",
            label: "Qual cobrança você se refere?",
            id: "Qual_cobranca_voce_se_refere__c",
          },
        ];
      case "Downgrade":
        return [
          {
            type: "text",
            label: "Você está ciente dos módulos que serão desabilitados?",
            id: "Sabe_dos_modulos_desabilitados__c",
          },
        ];
      case "Dúvidas sobre extensões":
        return [
          {
            type: "text",
            label: "Qual extensão?",
            id: "Qual_extenssao__c",
          },
        ];
      case "Erro cobrança":
        return [
          {
            type: "text",
            label: "Qual erro ocorreu?",
            id: "Qual_erro_ocorreu__c",
          },
        ];
      case "Nota fiscal de serviço (Solicitação/Dúvidas)":
        // TODO: Validar se o campo está correto, na planilha referência "Qual a NF ?"
        return [
          {
            type: "text",
            label: "Qual NF?",
            id: "Qual_NF__c",
          },
        ];
      case "Reativação de conta":
        return [
          {
            type: "text",
            label: "Na sua tela apresenta o valor de reativação?",
            id: "Apresenta_valor_de_reativacao__c",
          },
        ];
      case "Reenvio do Boleto de mensalidade":
        return [
          {
            type: "plaintext",
            label:
              "Precisa da segunda via do boleto? Acesse o menu lateral > Minha Conta > Detalhes de pagamento. Na coluna Formas de pagamento, clique em baixar boleto.",
          },
          {
            type: "text",
            label: "Qual o período?",
            id: "Qual_o_periodo__c",
          },
        ];
      case "Solicitação de boleto antecipado":
        return [
          {
            type: "text",
            label: "Qual o período?",
            id: "Qual_o_periodo__c",
          },
        ];
      case "Upgrade":
        return [
          {
            type: "text",
            label: "Para qual plano você gostaria de migrar?",
            id: "Para_qual_plano_voce_gostaria_de_migrar__c",
          },
        ];
      default:
        return [];
    }
  }

  return [];
};
